import { Injectable, EventEmitter } from '@angular/core';
import { OverlayRef } from '@angular/cdk/overlay';
import { Suggestion, ExtendedSuggestion } from '../../se-smart-text-editor/suggestion-datasource/suggestion';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SeSuggestionSelectorOverlayRef {
  selectedSuggestionEventEmitter = new EventEmitter<ExtendedSuggestion>();
  preSelectNextEventEmitter = new EventEmitter();
  preSelectPreviousEventEmitter = new EventEmitter();
  preSelectedSuggestionEmitter = new EventEmitter<Suggestion>();
  /* emits true when the overaly is opened and false when it is closed */
  overlayStatusEmitter = new BehaviorSubject<boolean>(true);
  
  
  isClosed = false;

  constructor(private overlayRef: OverlayRef) { 
     

  }

  close(): void {
    this.overlayRef.dispose();
    this.isClosed = true;
    this.selectedSuggestionEventEmitter.complete();
    this.preSelectNextEventEmitter.complete();
    this.preSelectPreviousEventEmitter.complete();
    this.preSelectedSuggestionEmitter.complete();
    this.overlayStatusEmitter.next(false);
    this.overlayStatusEmitter.complete();
  }

  preSelectNext() {
    this.preSelectNextEventEmitter.emit();
  }

  preSelectPrevious() {
    this.preSelectPreviousEventEmitter.emit();
  }

}
